import React, { useState } from 'react';
import { loginUser, signUpUser } from '../api/userApi';
import LoadingButton from './LoadingButton';

export default function LoginPage({ onLogin }: { onLogin: (user: any) => void }) {
  const [isSignUp, setIsSignUp] = useState(false);
  const [form, setForm] = useState<any>({});
  const [error, setError] = useState<string | null>(null);
  const [toast, setToast] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);
    try {
      if (isSignUp) {
        await signUpUser(form);
        setToast('Account registered successfully! You can now log in.');
        setIsSignUp(false);
        setForm({});
      } else {
        const response = await loginUser(form.email, form.password);
        if (response && response.statusCode === 200 && response.value) {
          const userData = {
            userId: response.value.userId,
            name: response.value.userName,
            email: form.email,
            role: response.value.role
          };
          onLogin(userData);
        } else {
          throw new Error('Invalid response from server');
        }
      }
    } catch (err: any) {
      const msg = err?.response?.data || 'Invalid email or password. Please try again.';
      setError(typeof msg === 'string' ? msg : 'An error occurred during authentication.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-card-wrapper">
      <div className="login-card-header">
        <div className="login-brand-logo">
          <img 
            src={require('../Assets/WebsiteLogo.png')} 
            alt="Jai Bhavani Fireworks" 
          />
        </div>
        <h2 className="login-title">{isSignUp ? 'Create Customer Account' : 'Welcome Back'}</h2>
        <p className="login-subtitle">
          {isSignUp 
            ? 'Sign up to manage and track your festive fireworks orders' 
            : 'Log in to your Jai Bhavani Fireworks account'}
        </p>
      </div>

      <form onSubmit={handleSubmit} className="login-form-body">
        {isSignUp && (
          <div className="signup-fields-grid">
            <div className="input-group">
              <label>Full Name *</label>
              <input name="name" placeholder="John Doe" required onChange={handleChange} />
            </div>
            <div className="input-group">
              <label>Mobile Number *</label>
              <input name="phoneNumber" placeholder="10-digit number" required onChange={handleChange} />
            </div>
            <div className="input-group full-width">
              <label>Address *</label>
              <input name="address" placeholder="Street, Area, Landmark" required onChange={handleChange} />
            </div>
            <div className="input-group">
              <label>City</label>
              <input name="city" placeholder="City" onChange={handleChange} />
            </div>
            <div className="input-group">
              <label>PIN Code</label>
              <input name="pinCode" placeholder="PIN code" onChange={handleChange} />
            </div>
          </div>
        )}

        <div className="input-group full-width">
          <label>Email Address *</label>
          <input 
            name="email" 
            type="email" 
            placeholder="name@example.com" 
            required 
            onChange={handleChange} 
            value={form.email || ''} 
          />
        </div>

        <div className="input-group full-width">
          <label>Password *</label>
          <input
            name={isSignUp ? "passwordHash" : "password"}
            type="password"
            placeholder="••••••••"
            required
            onChange={handleChange}
            value={isSignUp ? form.passwordHash || '' : form.password || ''}
          />
        </div>

        <LoadingButton
          type="submit"
          onClick={() => {}}
          loading={isSubmitting}
          className="login-submit-btn"
        >
          {isSignUp ? 'Create Account & Continue' : 'Sign In to Account'}
        </LoadingButton>
      </form>

      <div className="login-toggle-area">
        <button 
          type="button"
          className="login-toggle-btn" 
          onClick={() => { setIsSignUp(!isSignUp); setError(null); setToast(null); }}
        >
          {isSignUp ? 'Already registered? Sign In instead' : "Don't have an account? Sign Up now"}
        </button>
      </div>

      {error && <div className="login-error-alert">{error}</div>}
      {toast && <div className="login-success-alert">{toast}</div>}
    </div>
  );
}